import { useState } from 'react';
import { Info } from 'lucide-react';

/** Small info badge shown in the corner of a photo an admin has flagged as
 * possibly AI-edited/enhanced. Tap or hover reveals the disclosure text —
 * click-based so it also works on touch devices, not just desktop hover. */
export default function AiPhotoBadge() {
  const [open, setOpen] = useState(false);

  return (
    <div className="absolute bottom-2 right-2 z-10">
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          setOpen((o) => !o);
        }}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        aria-label="Photo disclosure"
        className="w-6 h-6 rounded-full bg-ink/70 text-paper flex items-center justify-center hover:bg-ink transition-colors border-none cursor-pointer"
      >
        <Info size={13} />
      </button>
      {open && (
        <div className="absolute bottom-full right-0 mb-2 w-[190px] px-3 py-2.5 rounded-md bg-ink text-paper text-[11.5px] leading-snug shadow-[0_8px_20px_rgba(0,0,0,0.3)]">
          This photo may have been edited or enhanced with AI.
        </div>
      )}
    </div>
  );
}
